import { createAction, props } from '@ngrx/store';
import { RestApiError, SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { AccountDetailSaveEvent } from '../models/account-detail-form-submit-event';
import { GetAccountDetail_account } from '../queries/generated/GetAccountDetail';
import { SaveAccount } from '../queries/generated/SaveAccount';

export const accountDetailLoad = createAction('[Account Detail] Load');

export const accountDetailCancel = createAction('[Account Detail] Cancel');

export const loadAccountDetailsSuccess = createAction(
   '[API] Load Account Success',
   props<{ data: GetAccountDetail_account }>()
);

export const loadAccountAccessDenied = createAction('[API] Load Account Access Denied');

export const loadAccountDetailsFailure = createAction('[API] Load Account Failure', props<SingleGraphError>());

export const saveAccountDetail = createAction('[Account Detail] Save', props<AccountDetailSaveEvent>());

export const saveAccountDetailSuccess = createAction('[Account Detail] Save Success', props<{ data: SaveAccount }>());

export const saveAccountDetailFailure = createAction('[Account Detail] Save Failure', props<SingleGraphError>());

export const addMohPrompt = createAction('[Account Detail] Add Prompt');

export const bulkConfigureExtensions = createAction(
   '[Bulk Configure Extensions] Load Bulk Configure Extensions Page',
   props<{ accountId: number }>()
);

export const rebootAllPhones = createAction('[Account Detail] Reboot All Phones', props<{ accountId: number }>());

export const rebootAllPhonesSuccess = createAction(
   '[Account Detail] Reboot All Phones Success',
   props<{ accountId: number }>()
);

export const rebootAllPhonesFailure = createAction(
   '[Account Detail] Reboot All Phones Failure',
   props<SingleGraphError>()
);

export const editPresenceCredentials = createAction(
   '[Account Detail] Edit Presence Credentials',
   props<{ username: string; presenceEnabled: boolean }>()
);

export const editPresenceCredentialsSubmit = createAction(
   '[Account Detail] Edit Presence Credentials Submit',
   props<{ password: string; confirmPassword: string; username: string; fields: string[] }>()
);

export const editPresenceCredentialsSuccess = createAction(`[Account Detail] Edit Presence Credentials Success`);

export const editPresenceCredentialsFailure = createAction(
   `[Account Detail] Edit Presence Credentials Failure`,
   props<RestApiError>()
);

export const navigate = createAction('[Account Detail] Navigate', props<{ id: number | string }>());
